import ConfigParameter, {gettext} from "../ConfigParameter";

export default class MapApiKey extends ConfigParameter {

    constructor() {
        super('apiKey', 'text', gettext('Map API key'), 'mainConfig', 'AIzaSyCx76iGb_5XO6gb9ZLGWeeO3Ok3EMUqbsc');
    }
}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/MapApiKey.js